import React, { useContext, useId } from "react";
import FilterLayoutContext from "./FilterLayoutContext";

export default function FilterGroup({ label, hint, className, children }) {
  const layout = useContext(FilterLayoutContext);
  const labelId = useId();

  return (
    <div
      className={`nfl-filter-group is-${layout}` + (className ? ` ${className}` : "")}
      role="group"
      aria-labelledby={labelId}
    >
      <div className="nfl-filter-label">
        <span id={labelId} className="nfl-filter-label-text nfl-display">
          {label}
        </span>
        {hint ? <span className="nfl-filter-hint">{hint}</span> : null}
      </div>
      {children}
    </div>
  );
}
